import axios from 'axios'
import box from '../utils/format'
import router from '../router'

// 创建axios实例
let service = axios.create({
    timeout: 60000, // 请求超时时间
    responseType: 'json',
    headers: {
        "Content-Type": "application/json",
        "webType": 'store',
        'country':'au',
        'Accept-Language': 'en-US'
    }
})

// const baseURL = 'https://admin-api.peiso.com.au'
// const baseURL = 'http://192.168.50.100:8997'


const baseURL = process.env.ENDPOINT_BASE_URL            // to reconfigure go to config.env.js and change the ENDPOINT_BASE_URL value


// request拦截器：对请求参数做监听和处理
service.interceptors.request.use(
    (config) => {
        config.headers.token = sessionStorage.getItem('token')
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// response拦截器：对相应数据做处理
service.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        return Promise.reject(error)
    }
)

const requestMethod = ['get', 'delete', 'post', 'put', 'patch']

const $axios = {}

requestMethod.forEach(method => {
    $axios[method] = function(url, data = {}, cancelToken) {
        return new Promise((resolve, reject) => {
            if (method === 'get') {
                service[method](`${baseURL}${url}`, {cache: false})
                .then(response => {
                    packageRespon(response, resolve);
                }, err => {
                    reject(err)
                    packageError(err)
                })
                .catch((error) => {
                    reject(error)
                    packageCatch(error)
                })
            } else {
                if (!service.defaults.headers.token) {
                    service.defaults.headers.token = sessionStorage.getItem('token')
                }

                if (data.subVenueId) {
                    service.defaults.headers.subVenueId = data.subVenueId
                }

                service[method](baseURL + url, data, {cancelToken: cancelToken})
                .then(response => {
                    packageRespon(response, resolve);
                }, err => {
                    reject(err)
                    packageError(err, url)
                })
                .catch((error) => {
                    reject(error)
                    packageCatch(error)
                })
            }
        })
    }
})

function packageRespon(res, resolve) {
    if (res.status == 200) {
        if(res.data==''||res.data==null){
            box.alert('', '请求异常，请稍后再试!' ,'error');
            return
        }
        /* if(res.data.code==90000||res.data.code==10000||res.data.code==401||res.data.code==90006||res.data.code==90001||res.data.code==90011){
            router.push({path: '/login'})
        }else if(res.data.code==8902){
            box.alert('', '账号无权限!' ,'error');
        }else if(res.data.code==90014){
            box.alert('', '该地区无权限操作!' ,'error');
        }else if(res.data.code==8901){
            router.push({path: '/login'})
            box.alert('', res.data.message ,'error');
        } */else{
            resolve(res);
        }
    } else {
        box.alert('', res.data.message ,'error');
    }
}


function packageError(err, url) {
    if (err !== 'Operationcanceled' && err.message !== 'Operationcanceled') {
        if (err == 'Error: timeout of 60000ms exceeded') {
            box.alert('', 'Unable to connect to the server.' ,'error');
        } else if (err == 'Error: Network Error' || err.message == 'Network Error'){
            box.alert('', 'Unable to connect to the server.', 'error')
        } else {
            box.alert('', err ,'error');
        }
    }
}


function packageCatch(err) {
    box.alert('', err ,'error');
}


export default $axios



// WEBPACK FOOTER //
// ./src/api/axios.js